<template>
  <div>
    <b-form-checkbox
      name="checks"
      class="mb-3"
      :disabled="disabled"
      :checked="value.includes(item.id)"
      @change="checked => toggleChecked(checked, item.id)"
    >
      {{ item.name }}
    </b-form-checkbox>

    <div
      v-if="children && children.length"
      :class="[`border-${borderVariant}`, {'pl-2 ml-2 border-left': $dir.ltr, 'pr-2 mr-2 border-right': $dir.rtl}]"
    >
      <item
        v-for="child in children"
        :key="child.id"
        :all="all"
        :item="child"
        :value="value"
        :border-variant="borderVariant"
        @toggleChecked="toggleChecked"
        @parentToggleDisable="toggleDisabled"
      />
    </div>
  </div>
</template>

<script>
import Item from './Item'

export default {
  name: 'Item',
  components: {
    Item
  },
  props: {
    item: { type: Object, required: true },
    all: { type: Array, required: true },
    value: { type: Array, required: true },
    borderVariant: { type: String, default: 'light' }
  },
  data () {
    return {
      disabled: false
    }
  },
  computed: {
    children () {
      return this.getChildren(this.item.id)
    }
  },
  mounted () {
    if (this.value && this.value.length && this.value.find(i => i === this.item.id)) {
      this.toggleChecked(true, this.item.id)
    }
  },
  methods: {
    getChildren (id) {
      return this.all.filter(i => i.parentIds[1] === id)
    },
    getPosterity (id) {
      const ids = []
      const childIds = this.getChildren(id).map(o => o.id)

      childIds.forEach(childId => {
        const posterityIds = this.getPosterity(childId)
        ids.push(childId)
        ids.push(...posterityIds)
      })

      return ids
    },
    hasCheckedPosterity () {
      const posterity = this.getPosterity(this.item.id)
      return this.value.find(i => posterity.find(j => j === i))
    },
    toggleDisabled (value) {
      this.$nextTick(() => {
        this.toggleChecked(false, this.item.id)

        this.$nextTick(() => {
          if (!value) {
            const hasCheckedPosterity = this.hasCheckedPosterity()

            if (!hasCheckedPosterity) {
              this.disabled = value
              this.$emit('parentToggleDisable', value)
            }
          } else {
            this.disabled = value
            this.$emit('parentToggleDisable', value)
          }
        })
      })
    },
    toggleChecked (checked, id) {
      this.$emit('toggleChecked', checked, id)
      this.$nextTick(() => {
        this.$emit('parentToggleDisable', checked)
      })
    }
  }
}
</script>
